var map = {
	"./1.jpg": 71581,
	"./1Old.jpg": 92434,
	"./2.jpg": 61682,
	"./3.jpg": 29615,
	"./4.jpg": 51652,
	"./installation1.jpg": 38013,
	"./installation3.jpg": 495,
	"./installation4.jpg": 75556
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74969;